import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { State } from "@/store/modules/speedNetworking";

const getUserInMeeting = (state: State): SpaceUserInterface | null => {
  return state.userInMeeting;
};

const getWaitingMeeting = (state: State): boolean => {
  return state.waitingMeeting;
};

const getEnterInNetworking = (state: State): boolean => {
  return state.enterInNetworking;
};

const getShowEnterModal = (state: State): boolean => {
  return state.showEnterModal;
};

const getWaitingTime = (state: State) => {
  return state.waitingTime;
};

const getMeetingTime = (state: State) => {
  return state.meetingTime;
};

export default {
  getUserInMeeting,
  getWaitingMeeting,
  getEnterInNetworking,
  getShowEnterModal,
  getWaitingTime,
  getMeetingTime,
};
